module.exports = __webpack_public_path__ + "img/confrim.40c84cab.png";